import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
  Grid,
  Menu,
  ListItemIcon,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import Swal from "sweetalert2";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";
import { useAuth } from "../../../AuthProvider";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const ClassTeachersList = () => {
  const navigate = useNavigate();
  const [classsearchQuery, setClasssearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // const [filteredData1, setFilteredData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const { oId ,board,pId,userId,role} = useAuth();
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };


    const [users, setUsers] = useState([]);
        const [selectedUsers, setSelectedUsers] = useState('');
        const isPrincipal = role?.startsWith("PRINCIPAL") || false;
        const UserId = userId || selectedUsers;
      
        useEffect(() => {
          const fetchUsers = async () => {
              try {
                  const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                  if (!response.ok) {
                      throw new Error('Failed to fetch users');
                  }
                  const data = await response.json();
                  setUsers(data);
                  if (data.length > 0) {
                    setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                }
              } catch (error) {
                  console.error('Error fetching users:', error);
              }
          };
          fetchUsers();
      }, []);

 
    const fetchData = async () => {
      if(!UserId) return;
      setLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/classTeacher/getAllClassTeachers/${oId}/${pId}/${UserId}`
        );
        const data = await response.json();

        if (Array.isArray(data)) {
          setFilteredData(data); // Set only if data is an array
        } else {
          console.error("Expected an array but got:", data);
          setFilteredData([]); // Fallback to an empty array
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
        setFilteredData([]); // Prevent map error
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchData();
  }, [UserId]);

  const filteredResults = filteredData.filter((item) => {
    const teacherFirstName = item.teacherFirstName?.toLowerCase() || "";
    const teacherLastName = item.teacherLastName?.toLowerCase() || "";
    const romanClass = item.romanNumberClass?.toLowerCase() || "";
    const section = item.sections?.toLowerCase() || "";
    const fullName = `${teacherFirstName} ${teacherLastName}`;
    const query = classsearchQuery?.toLowerCase() || "";
  
    return (
      fullName.includes(query) ||
      romanClass.includes(query) ||
      section.includes(query)
    );
  });
  


  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading
  const [drivers, setDriversData] = useState([]);
 const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state

  const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

  // const handleSaveChanges = async () => {
  //   console.log("Selected Row Data before update:", selectedRow);
  //   setDialogbtnloading(true); // Start loading
  //   try {
  //     const formData = new FormData();
  
  //     // Append each key-value pair to FormData
  //     Object.keys(selectedRow).forEach((key) => {
  //       if (selectedRow[key] !== null && selectedRow[key] !== undefined) {
  //         formData.append(key, selectedRow[key]);
  //       }
  //     });
  
  //     // Ensure the correct ID is used
  //     const response = await fetch(
  //       `${baseUrl}/api/classTeacher/updateClassTeacher/${selectedRow.id}/TEACHER/${oId}`,
  //       {
  //         method: "PATCH",
  //         body: formData,
  //       }
  //     );
  
  //     const responseData = await response.json();
  
  //     if (!response.ok) {
  //       throw new Error(responseData.message || "Failed to update the details.");
  //     }
  
  //     toast.success("Driver Details updated successfully!");
  
  //     // Correctly update only the modified row
  //     setDriversData((prevData) =>
  //       prevData.map((driver) =>
  //         driver.drId === selectedRow.drId
  //           ? { ...driver, ...selectedRow }
  //           : driver
  //       )
  //     );
  
  //     handleDialogClose();
  //   } catch (error) {
  //     console.error("Error updating details:", error);
  //     toast.error(`Error updating details: ${error.message}`);
  //   }finally {
  //     setDialogbtnloading(false); // Stop loading
  //   }
  // };

  const handleSaveChanges = async () => {
    console.log("Selected Row Data before update:", selectedRow);
    setDialogbtnloading(true); // Start loading
  
    try {
      const formData = new FormData();
  
      // Append each key-value pair except teacherEmailId and teacherContactNumber
      Object.keys(selectedRow).forEach((key) => {
        if (
          selectedRow[key] !== null &&
          selectedRow[key] !== undefined &&

          key !== "teacherEmailId" && // Exclude teacherEmailId
          key !== "id" && // Exclude teacherEmailId
          key !== "teacherId" && // Exclude teacherEmailId
          key !== "teacherContactNumber" // Exclude teacherContactNumber
        ) {
          formData.append(key, selectedRow[key]);
        }
      });
  
      // Ensure the correct ID is used
      const response = await fetch(
        `${baseUrl}/api/classTeacher/updateClassTeacher/${selectedRow.id}/TEACHER/${oId}`,
        {
          method: "PATCH",
          body: formData,
        }
      );
  
      const responseData = await response.json();
  
      if (!response.ok) {
        throw new Error(responseData.message || "Failed to update the details.");
      }
  
      toast.success("Teacher Details updated successfully!");
      fetchData();
     
      // handleDialogClose();
    } catch (error) {
      console.error("Error updating details:", error);
      toast.error(`Error updating details: ${error.message}`);
    } finally {
      setDialogbtnloading(false); // Stop loading
    }
  };
 

  const handleDeleteClick = async (row) => {
    if (!row.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }
  
    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      text: `You Want To Remove Class Teacher "${row.teacherFirstName} ${row.teacherLastName}"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.id);
          const response = await fetch(
            `${baseUrl}/api/classTeacher/deleteClassTeacher/${row.id}/${oId}`,
            {
              method: "DELETE",
            }
          );
  
          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }
  
          toast.success("Class Teacher Deleted successfully!", {
            autoClose: 1000, // Closes after 1 second (1000ms)
          });
          fetchData();
          
  
          // // Remove the row from state after successful deletion
          // setFilteredData((prevData) =>
          //   prevData.filter((row) => row.id !== row.drId)
          // );
  
         
        } catch (error) {
          console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };





  const exportToExcel = () => {
    const processedData = filteredData.map(
      ({
        course,
        romanNumberClass,sections,
        teacherFirstName,teacherLastName,
        subject,
        teacherContactNumber,
        teacherEmailId,
      }) => ({
        Course: course,
        Class: romanNumberClass,
        Section: sections,
        TeacherName: `${teacherFirstName} ${teacherLastName}`,
        Subject: subject,
        ContactNumber: teacherContactNumber,
        Email: teacherEmailId || "N/A",
        
      })
    );

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Class_Teachers_List");
    

    // Add headers
    worksheet.columns = [
    //   { header: "S.No", key: "Sno", width: 15 },
    ...(board === "INTERMEDIATE"
      ? [{ header: "Course", key: "Course", width: 15 }]
      : []),
      { header: "Class", key: "Class", width: 15 },

      { header: "Section", key: "Section", width: 25 },
      { header: "Teacher Name", key: "TeacherName", width: 20 },
      { header: "Subject", key: "Subject", width: 30 },
      { header: "Mobile No", key: "ContactNumber", width: 40 },
      { header: "Email", key: "Email", width: 40 },
    ];

    // Add data to worksheet
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });

    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });

    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Class_Teachers_List.xlsx";
      link.click();
    });

    handleExportClose();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Class Teachers List", 10, 8);

    // Table
    doc.autoTable({
      startY: 20,
      head: [
        [
          "S.No",
          "Class",
          "Section",
          "Teacher Name",
          "Subject",
          "Mobile No",
          "Eamil"
        ],
      ],
      body: filteredData.map((row, index) => [
        index + 1,
        row.romanNumberClass,
        row.sections,
        `${row.teacherFirstName} ${row.teacherLastName}`,
        row.subject,
        row.teacherContactNumber,
        row.teacherEmailId || "N/A",
      ]),
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181], // Dark Blue Header
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });

    doc.save("Class_Teachers_List.pdf");
    handleExportClose();
  };

  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `Class_Teachers_List.json`;
    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              mb: 2,
              textAlign: "center",
              fontSize: "23px",
            }}
          >
            Class Teachers List
          </Typography>

          <Box
            display="flex"
            justifyContent="space-between" // Align search bar left and buttons right
            mb={3}
            flexWrap="wrap"
          >
           <Box
  display="flex"
  alignItems="center"
  flexWrap="wrap"
  gap={2}
>
  {/* Search Field */}
  <TextField
    label={`Search by Name or ${board === "INTERMEDIATE" ? "Year" : "Class"}`}
    variant="outlined"
    size="small"
    value={classsearchQuery}
    onChange={(e) => setClasssearchQuery(e.target.value)}
    sx={{ minWidth: 220 }}
  />

  {/* Principal Only - Select User Dropdown */}
  {/* {isPrincipal && (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel>Select Schedule Admin</InputLabel>
      <Select
        value={selectedUsers}
        onChange={(e) => setSelectedUsers(e.target.value)}
        label="Select Schedule Admin"
      >
        {users.map((user) => (
          <MenuItem key={user.userId} value={user.userId}>
            {user.userId} - {user.firstName} {user.lastName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )} */}
</Box>


            <Box display="flex" gap={2}>
              {" "}
              {/* Wrapper for buttons with a gap */}
            
              <Button
                variant="contained"
                onClick={handleExportClick}
                // style={{ backgroundColor: '#1565c0', fontWeight: 'bold' }}
                sx={{
                  backgroundColor: "#6E69B0",
                  color: "white",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#58548E",
                  },
                }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#6E69B0",
                  color: "white",
                  fontWeight:'bold',
                  "&:hover": {
                    backgroundColor: "#58548E",
                  },
                }}
                onClick={() => navigate("/ClassTeacherForm")}
              >
                Assign Class Teacher
              </Button>
            </Box>

            <Menu
              anchorEl={exportAnchorEl}
              open={isExportMenuOpen}
              onClose={handleExportClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                },
              }}
            >
              <MenuItem
                onClick={exportToExcel}
                sx={{
                  color: "#3f51b5",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e8f0fe",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#00796b" }}>
                  <SimCardDownloadIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Excel"
                  sx={{ fontWeight: "bold", color: "#00796b" }}
                />
              </MenuItem>

              <MenuItem
                onClick={exportToPDF}
                sx={{
                  color: "#d32f2f",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#fdecea",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#d32f2f" }}>
                  <PictureAsPdfIcon />
                </ListItemIcon>
                <ListItemText
                  primary="PDF"
                  sx={{ fontWeight: "bold", color: "#d32f2f" }}
                />
              </MenuItem>

              <MenuItem
                onClick={exportToJSON}
                sx={{
                  color: "#388e3c",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e8f5e9",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "#6a1b9a" }}>
                  <FilePresentIcon />
                </ListItemIcon>
                <ListItemText
                  primary="JSON"
                  sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                />
              </MenuItem>
            </Menu>
          </Box>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    S.No
                  </TableCell>
                   {(board === "INTERMEDIATE" ) && (
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ddd",
                                        padding: "4px",
                                        backgroundColor: "#fff9c4",
                                        textAlign: "center",
                                        fontWeight: "Bold",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Course
                                    </TableCell>
                                    )}
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                     {board === "INTERMEDIATE" ? "Year" : "Class"}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      fontSize: "14px",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "bold",
                    }}
                  >
                    Section
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Teacher Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Subject
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      <CircularProgress size={20} />
                    </TableCell> */}

                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredResults.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredResults.map((row, index) => (
                    <TableRow
                      key={row.id}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.romanNumberClass}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.sections}
                      </TableCell>
                      <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "2px",
    textAlign: "center",
    maxWidth: "80px",
    minWidth: "80px",
  }}
>
  <Box
    sx={{
      whiteSpace: "normal",       // Allow wrapping
      wordBreak: "break-word",    // Break long words
      overflowWrap: "break-word",
      fontSize: "13px",
    }}
  >
    {row.teacherFirstName} {row.teacherLastName}
  </Box>
</TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.subject}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherContactNumber}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherEmailId || "N/A"}
                      </TableCell>
{/* 
                      <TableCell sx={{ minWidth: "100px", textAlign: "center", padding: "4px" }}>
                                          <Box
                                                                sx={{
                                                                  display: "flex",
                                                                  justifyContent: "center",
                                                                  gap: "4px",
                                                                }}
                                                              >
         
                                            <Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                                    onClick={() => handleEditClick(row)}
                                                  >
                                                    Edit
                                            </Button>
                                          </Box>
                        </TableCell> */}
                        <TableCell sx={{ minWidth: "100px", textAlign: "center", padding: "4px" }}>
              <Box
                                                                sx={{
                                                                  display: "flex",
                                                                  justifyContent: "center",
                                                                  gap: "4px",
                                                                }}
                                                              >
         
                                                  {/* <Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                                    onClick={() => handleEditClick(row)}
                                                  >
                                                    Edit
                                                  </Button> */}

             
              <Button
                                                     sx={{
                                                      backgroundColor: "#a82814",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                                      // borderRadius: 2,
                                                      padding: "4px 6px",
                                                    }}
                                                    onClick={() => handleDeleteClick(row)}
                                                  >
                                                    Delete
                                                  </Button>
                                                  </Box>
            </TableCell>





                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>


 {/* Dialog for editing */}
 <Dialog 
 open={isDialogOpen}
  // onClose={handleDialogClose}
  >
              <DialogTitle style={{ fontWeight: "bold"}}>Update Teacher Details</DialogTitle>
              <DialogContent>
              <Grid container spacing={2}>
  {/* Name */}


  {/* CLASS */}
  <Grid item xs={6}>
    <TextField
      label="Class"
      value={selectedRow ? selectedRow.romanNumberClass : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          romanNumberClass: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
      disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }}
    />
  </Grid>

  {/* Section */}
  <Grid item xs={6}>
    <TextField
      label="Section"
      value={selectedRow ? selectedRow.sections : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          sections: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
      disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }}
    />
  </Grid>

  {/* Teacher Name*/}
  <Grid item xs={6}>
  <TextField
    label=" Teacher Name"
    value={selectedRow ? `${selectedRow.teacherFirstName || ""} ${selectedRow.teacherLastName || ""}`.trim() : ""}
    onChange={(e) => {
      const nameParts = e.target.value.trim().split(" ");
      const teacherFirstName = nameParts.length > 0 ? nameParts[0] : ""; // First word as teacherFirstName
      const teacherLastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : ""; // Remaining words as teacherLastName
      
      setSelectedRow((prevState) => ({
        ...prevState,
        teacherFirstName,
        teacherLastName,
      }));
    }}
    fullWidth
    margin="normal"
    size="small" // Reduced height
  />
</Grid>










  <Grid item xs={6}>
    <TextField
      label="Subject"
      value={selectedRow ? selectedRow.subject : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          subject: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
    />
  </Grid>

 

  {/* Driver Mobile */}
  <Grid item xs={6}>
    <TextField
      label="Mobile No"
      value={selectedRow ? selectedRow.teacherContactNumber : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          teacherContactNumber: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
    />
  </Grid>

  {/* Driver Email */}
  <Grid item xs={6}>
    <TextField
      label="Teacher Email"
      value={selectedRow ? selectedRow.teacherEmailId : ""}
      onChange={(e) =>
        setSelectedRow((prevState) => ({
          ...prevState,
          teacherEmailId: e.target.value,
        }))
      }
      fullWidth
      margin="normal"
      size="small"
    />
  </Grid>




</Grid>

</DialogContent>

              <DialogActions>
              <Button
      // onClick={handleDialogClose}
      color="primary"
      variant="outlined"
      
    >
      Cancel
    </Button>
    
    <Button
      // onClick={handleSaveChanges}
      color="primary"
      variant="contained"
      disabled={dialogbtnloading} // Disable when loading
      sx={{
        fontWeight: 600,
        backgroundColor: "#3C3972",
        "&:hover": { backgroundColor: "#3C3972" },
      }}
      
    >
      {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
    </Button>
    
              </DialogActions>
            </Dialog>


        <ToastContainer position="top-right" autoClose={1000}  />





        </CardContent>
      </Card>
    </Box>
  );
};

export default ClassTeachersList;